import * as React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Container, ListLayout, LinkModule } from "@/components"
import t from "@/constants/wording"
import * as styles from "./index.module.scss"

const ProductAdvantages: React.FC<{ isShowLookDetailLink?: boolean, myData?: ProductAdvantages[] }> = ({ isShowLookDetailLink = true, myData }) => {
  // const data: ProductAdvantages[] = myData ?? queryData.allStrapiProductAdvantages.nodes ?? []

  const data = myData ?? []


  return (
    <>
      {data && data.length > 0 && (
        <div className={styles.technicalAdvantages}>
          <Container>
            <ListLayout
              listData={data}
              className={styles.technicalAdvantagesList}
            >
              {item => (
                <div className={styles.inner}>
                  {item && item.banner && (
                    <div className={styles.logo}>
                      <img alt={item.banner.alt} src={item.banner.media.url} />
                    </div>
                  )}
                  <h2>{item.title}</h2>
                  <p className={styles.p1}>{item.description}</p>
                  {isShowLookDetailLink && (
                    <div className={styles.lookDetail}>
                      <LinkModule to={`/product-advantages-detail/${item.id}`}>
                        {t("look detail")}
                      </LinkModule>
                    </div>
                  )}
                </div>
              )}
            </ListLayout>
          </Container>
        </div>
      )}
    </>
  )
}

export default ProductAdvantages
